import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  KeyboardAvoidingView,
  Image,
  Alert,
} from '../../src/web/react-native';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import Icon from '../../src/components/Icon';
import Location from './../../img/location.svg';
import Privacy from './../../img/privacy.svg';
import LinearGradient from '../../src/components/LinearGradient';
import { userActions, selectUser, selectCurrentSiteCode, persistor } from '../../src/store';
import { Route } from '../../src/app/Route';
import { TextField } from '../../src/components';
import service from '../../Service/service';
import { ScrollView } from '../../src/web/react-native';
import { DdLogs } from '../../src/logging/datadog';

const LocationIcon = Image;
const PrivacyIcon = Image;

export function Menu(props) {
  const dispatch = useDispatch();
  let [width, setWidth] = useState(Dimensions.get('window').width);
  const [appFeedback, setAppFeedback] = useState('');
  const [reportIssues, setReportIssues] = useState('');
  const [sendingAppFeedback, setSendingAppFeedback] = useState(false);
  const [sendingReportIssues, setSendingReportIssues] = useState(false);
  const siteCode = selectCurrentSiteCode.useHook();
  const user = selectUser.useHook();
  useEffect(() => {
    Dimensions.addEventListener('change', () => {
      setWidth(Dimensions.get('window').width);
    });
  }, []);

  const logoutTapped = () => {
    // The page keeps running until the logout redirect leaves it; without pausing, any state change re-saves the cleared data.
    persistor.pause();
    persistor
    .flush()
    .then(() => dispatch(userActions.clearCachedStorage()).unwrap())
    .then(() => dispatch(userActions.logout()).unwrap())
    .then(() => props.setMenuVisible(false))
    .catch((error) => {
      persistor.persist();
      DdLogs.error('Unable to complete logout', error);
      Alert.alert('Logout failed', 'Unable to complete logout. Please try again.');
    });
  };

  const [clearingCache, setClearingCache] = useState(false);

  // Unregisters the service worker and clears caches so clients stuck on an
  // old build can pick up the latest version on the next load.
  const clearCacheAndUpdate = async () => {
    setClearingCache(true);
    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }
    } finally {
      window.location.reload();
    }
  };

  const sendAppFeedback = async () => {
    setSendingAppFeedback(true);
    await service.sendFeedback({
      text: appFeedback,
      metadata: { SiteCode: siteCode },
      type: 'suggestion',
    });
    setSendingAppFeedback(false);
    setAppFeedback('');
  };

  const sendReportIssues = async () => {
    setSendingReportIssues(true);
    await service.sendFeedback({
      text: reportIssues,
      metadata: { SiteCode: siteCode },
      type: 'issue',
    });
    setSendingReportIssues(false);
    setReportIssues('');
  };

  return (
    <SafeAreaView
      style={{
        width: 0.85 * width,
        height: '100%',
        backgroundColor: '#2a5899',
        paddingTop: 'env(safe-area-inset-top)'
      }}>
      <LinearGradient
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={['#2a5899', '#2a5899']}
        style={{ height: 150 }}>
        <View style={{ flex: 2, justifyContent: 'center', marginLeft: 10 }}>
          <View style={{ marginBottom: 3 }}>
            {user && <Text style={{ fontSize: 20, color: '#fff' }}>{user?.name}</Text>}
          </View>
          <View>
            <Text style={{ fontSize: 14, color: '#fff' }}>
              {props.preference.shiftName +
                ' | ' +
                moment(props.preference.currentShiftStart)
                  .format('h:mm a')
                  .concat(' - ')
                  .concat(moment(props.preference.currentShiftEnd).format('h:mm a'))}
            </Text>
          </View>
        </View>
        <View style={{ flex: 1.5, marginLeft: 10 }}>
          <View style={{ marginBottom: 3 }}>
            <Text style={{ color: '#fff' }}>{props.preference.path?.split('\\').join(' | ')}</Text>
          </View>
          <View>{user && <Text style={{ color: '#fff', fontSize: 14 }}>{user.email}</Text>}</View>
        </View>
      </LinearGradient>
      <KeyboardAvoidingView behavior="position">
        <ScrollView
          automaticallyAdjustKeyboardInsets={true}
          style={{ backgroundColor: '#F4F8F9', paddingHorizontal: 10, paddingVertical: 6 }}>
          <View style={{ margin: 10}}>
            <Text style={{ fontWeight: 'bold' }}>Settings</Text>
          </View>
          <TouchableOpacity
            onPress={() => {
              props.propsCarryover.navigation.navigate(Route.preferenceNavScreen, {
                canNavigateBack: true,
                fromMenu: true,
              });

              props.setMenuVisible(false);
            }}>
            <View
              style={{
                borderRadius: 4,
                height: 50,
                backgroundColor: '#fff',
                flexDirection: 'row',
                padding: 10,
                alignItems: 'center',
                justifyContent: 'space-between',
                shadowColor: '#E7ECEF',
                shadowOffset: { width: 0, height: 6 },
                shadowOpacity: 1,
              }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <LocationIcon source={Location} style={{ marginRight: 10 }} />
                <Text style={{ color: '#5A5A5A' }}>Site, Plant, Console, Post</Text>
              </View>
              <Icon name="chevron-forward" size={24} color="#686868" /> 
            </View>
          </TouchableOpacity>
          <View style={{ margin: 10 }}>
            <Text style={{ fontWeight: 'bold' }}>App Info  
              <span style= {{color: '#9aa5b1', marginLeft: '3px'}}>
                (Version {__APP_VERSION__})
                </span>  
            </Text>
          </View>

          {[
            {
              title: 'Send Feedback',
              value: appFeedback,
              set: setAppFeedback,
              send: sendAppFeedback,
              sending: sendingAppFeedback,
            },
            {
              title: 'Report Issues',
              value: reportIssues,
              set: setReportIssues,
              send: sendReportIssues,
              sending: sendingReportIssues,
            },
          ].map((item) => (
            <View
              key={item.title}
              style={{
                borderRadius: 4,
                marginBottom: 10,
                backgroundColor: '#fff',
                flexDirection: 'column',
                padding: 10,
                minHeight: 100,
                shadowColor: '#E7ECEF',
                shadowOffset: { width: 0, height: 6 },
                shadowOpacity: 1,
              }}>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <PrivacyIcon source={Privacy} style={{ marginRight: 10 }} />
                  <Text style={{ color: '#5A5A5A', overflow: 'scroll' }}>{item.title}</Text>
                </View>
                <TouchableOpacity
                  style={{
                    backgroundColor: item.sending ? 'gray' : '#0b479d',
                    padding: 4,
                    borderRadius: 4,
                  }}
                  onPress={item.send}
                  disabled={item.sending}>
                  <Text style={{ color: 'white', fontWeight: 'bold' }}>
                    {item.sending ? 'Sending' : 'Send'}
                  </Text>
                </TouchableOpacity>
              </View>
              <TextField value={item.value} onChangeText={(e) => item.set(e)} />
            </View>
          ))}

          <TouchableOpacity onPress={clearCacheAndUpdate} disabled={clearingCache}>
            <View
              style={{
                borderRadius: 4,
                marginBottom: 10,
                height: 50,
                backgroundColor: '#fff',
                flexDirection: 'row',
                paddingHorizontal: 10,
                alignItems: 'center',
                justifyContent: 'space-between',
                shadowColor: '#E7ECEF',
                shadowOffset: { width: 0, height: 6 },
                shadowOpacity: 1,
              }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', paddingLeft: 10 }}>
                <Icon name="refresh" size={24} color="#686868" style={{ marginRight: 10 }} />
                <Text style={{ color: '#5A5A5A' }}>
                  {clearingCache ? 'Clearing cache…' : 'Clear Cache & Update'}
                </Text>
              </View>
            </View>
          </TouchableOpacity>

          <TouchableOpacity onPress={logoutTapped}>
            <View
              style={{
                borderRadius: 4,
                marginBottom: 10,
                height: 50,
                backgroundColor: '#fff',
                flexDirection: 'row',
                paddingHorizontal: 10,
                alignItems: 'center',
                justifyContent: 'space-between',
                shadowColor: '#E7ECEF',
                shadowOffset: { width: 0, height: 6 },
                shadowOpacity: 1,
              }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', paddingLeft: 10 }}>
                <PrivacyIcon source={Privacy} style={{ marginRight: 10 }} />
                <Text style={{ color: '#5A5A5A' }}>Log Out</Text>
              </View>
            </View>
          </TouchableOpacity>
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

const mapStateToProps = (state) => ({
  preference: state.preference.preferences,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
